import { atom } from "jotai";

//報告タブでの「自動完了」を選択した場合保持
export const autoCompeleteSelectFlag = atom(false);
autoCompeleteSelectFlag.debugLabel = "autoCompeleteSelectFlag";
